module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_2.906b8809.png";